/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AssinarDocumentoDto,
  AtualizarReceituarioDto,
  AtualizarTemplateDto,
  CompartilharReceituarioDto,
  CompartilharReceituarioPorEmailDto,
  CriarReceituarioDto,
  CriarTemplateDto,
  ErroResponse,
  LinkCompartilhadoResponse,
  ListaDeTemplatesResponse,
  PaginaDeReceituariosResponse,
  ReceituarioResponse,
  ReceituariosControllerListarParams,
  TemplateResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getReceituariosControllerListarTemplatesUrl = () => {




  return `/v1/receituarios/templates`
}

/**
 * @summary Modelos DO VETERINÁRIO da sessão — não os da clínica
 */
export const receituariosControllerListarTemplates = async ( options?: Parameters<typeof httpClient>[1]): Promise<ListaDeTemplatesResponse> => {

  return httpClient<ListaDeTemplatesResponse>(getReceituariosControllerListarTemplatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReceituariosControllerListarTemplatesQueryKey = () => {
    return [
    `/v1/receituarios/templates`
    ] as const;
    }


export const getReceituariosControllerListarTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof receituariosControllerListarTemplates>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerListarTemplates>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReceituariosControllerListarTemplatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof receituariosControllerListarTemplates>>> = ({ signal }) => receituariosControllerListarTemplates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerListarTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReceituariosControllerListarTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof receituariosControllerListarTemplates>>>
export type ReceituariosControllerListarTemplatesQueryError = unknown


export function useReceituariosControllerListarTemplates<TData = Awaited<ReturnType<typeof receituariosControllerListarTemplates>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerListarTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof receituariosControllerListarTemplates>>,
          TError,
          Awaited<ReturnType<typeof receituariosControllerListarTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReceituariosControllerListarTemplates<TData = Awaited<ReturnType<typeof receituariosControllerListarTemplates>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerListarTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof receituariosControllerListarTemplates>>,
          TError,
          Awaited<ReturnType<typeof receituariosControllerListarTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReceituariosControllerListarTemplates<TData = Awaited<ReturnType<typeof receituariosControllerListarTemplates>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerListarTemplates>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Modelos DO VETERINÁRIO da sessão — não os da clínica
 */

export function useReceituariosControllerListarTemplates<TData = Awaited<ReturnType<typeof receituariosControllerListarTemplates>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerListarTemplates>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReceituariosControllerListarTemplatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getReceituariosControllerCriarTemplateUrl = () => {




  return `/v1/receituarios/templates`
}

/**
 * @summary Cria um modelo. O nome é único por veterinário.
 */
export const receituariosControllerCriarTemplate = async (criarTemplateDto: CriarTemplateDto, options?: Parameters<typeof httpClient>[1]): Promise<TemplateResponse> => {

  return httpClient<TemplateResponse>(getReceituariosControllerCriarTemplateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarTemplateDto)
  }
);}





export const getReceituariosControllerCriarTemplateMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerCriarTemplate>>, TError,{data: CriarTemplateDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerCriarTemplate>>, TError,{data: CriarTemplateDto}, TContext> => {

const mutationKey = ['receituariosControllerCriarTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receituariosControllerCriarTemplate>>, {data: CriarTemplateDto}> = (props) => {
          const {data} = props ?? {};

          return  receituariosControllerCriarTemplate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReceituariosControllerCriarTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof receituariosControllerCriarTemplate>>>
    export type ReceituariosControllerCriarTemplateMutationBody = CriarTemplateDto
    export type ReceituariosControllerCriarTemplateMutationError = ErroResponse

    /**
 * @summary Cria um modelo. O nome é único por veterinário.
 */
export const useReceituariosControllerCriarTemplate = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerCriarTemplate>>, TError,{data: CriarTemplateDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof receituariosControllerCriarTemplate>>,
        TError,
        {data: CriarTemplateDto},
        TContext
      > => {
      return useMutation(getReceituariosControllerCriarTemplateMutationOptions(options), queryClient);
    }
    export const getReceituariosControllerAtualizarTemplateUrl = (templateId: string,) => {




  return `/v1/receituarios/templates/${templateId}`
}

/**
 * @summary Edita um modelo próprio
 */
export const receituariosControllerAtualizarTemplate = async (templateId: string,
    atualizarTemplateDto: AtualizarTemplateDto, options?: Parameters<typeof httpClient>[1]): Promise<TemplateResponse> => {

  return httpClient<TemplateResponse>(getReceituariosControllerAtualizarTemplateUrl(templateId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarTemplateDto)
  }
);}





export const getReceituariosControllerAtualizarTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerAtualizarTemplate>>, TError,{templateId: string;data: AtualizarTemplateDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerAtualizarTemplate>>, TError,{templateId: string;data: AtualizarTemplateDto}, TContext> => {

const mutationKey = ['receituariosControllerAtualizarTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receituariosControllerAtualizarTemplate>>, {templateId: string;data: AtualizarTemplateDto}> = (props) => {
          const {templateId,data} = props ?? {};

          return  receituariosControllerAtualizarTemplate(templateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReceituariosControllerAtualizarTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof receituariosControllerAtualizarTemplate>>>
    export type ReceituariosControllerAtualizarTemplateMutationBody = AtualizarTemplateDto
    export type ReceituariosControllerAtualizarTemplateMutationError = unknown

    /**
 * @summary Edita um modelo próprio
 */
export const useReceituariosControllerAtualizarTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerAtualizarTemplate>>, TError,{templateId: string;data: AtualizarTemplateDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof receituariosControllerAtualizarTemplate>>,
        TError,
        {templateId: string;data: AtualizarTemplateDto},
        TContext
      > => {
      return useMutation(getReceituariosControllerAtualizarTemplateMutationOptions(options), queryClient);
    }
    export const getReceituariosControllerExcluirTemplateUrl = (templateId: string,) => {




  return `/v1/receituarios/templates/${templateId}`
}

/**
 * @summary Exclui o modelo. Delete físico — nenhuma receita aponta para ele.
 */
export const receituariosControllerExcluirTemplate = async (templateId: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getReceituariosControllerExcluirTemplateUrl(templateId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getReceituariosControllerExcluirTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerExcluirTemplate>>, TError,{templateId: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerExcluirTemplate>>, TError,{templateId: string}, TContext> => {

const mutationKey = ['receituariosControllerExcluirTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receituariosControllerExcluirTemplate>>, {templateId: string}> = (props) => {
          const {templateId} = props ?? {};

          return  receituariosControllerExcluirTemplate(templateId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReceituariosControllerExcluirTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof receituariosControllerExcluirTemplate>>>

    export type ReceituariosControllerExcluirTemplateMutationError = unknown

    /**
 * @summary Exclui o modelo. Delete físico — nenhuma receita aponta para ele.
 */
export const useReceituariosControllerExcluirTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerExcluirTemplate>>, TError,{templateId: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof receituariosControllerExcluirTemplate>>,
        TError,
        {templateId: string},
        TContext
      > => {
      return useMutation(getReceituariosControllerExcluirTemplateMutationOptions(options), queryClient);
    }
    export const getReceituariosControllerListarUrl = (params?: ReceituariosControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/receituarios?${stringifiedParams}` : `/v1/receituarios`
}

/**
 * @summary Lista os receituários do ambiente
 */
export const receituariosControllerListar = async (params?: ReceituariosControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeReceituariosResponse> => {

  return httpClient<PaginaDeReceituariosResponse>(getReceituariosControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReceituariosControllerListarQueryKey = (params?: ReceituariosControllerListarParams,) => {
    return [
    `/v1/receituarios`, ...(params ? [params] : [])
    ] as const;
    }


export const getReceituariosControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof receituariosControllerListar>>, TError = ErroResponse>(params?: ReceituariosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReceituariosControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof receituariosControllerListar>>> = ({ signal }) => receituariosControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReceituariosControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof receituariosControllerListar>>>
export type ReceituariosControllerListarQueryError = ErroResponse


export function useReceituariosControllerListar<TData = Awaited<ReturnType<typeof receituariosControllerListar>>, TError = ErroResponse>(
 params: undefined |  ReceituariosControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof receituariosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof receituariosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReceituariosControllerListar<TData = Awaited<ReturnType<typeof receituariosControllerListar>>, TError = ErroResponse>(
 params?: ReceituariosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof receituariosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof receituariosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReceituariosControllerListar<TData = Awaited<ReturnType<typeof receituariosControllerListar>>, TError = ErroResponse>(
 params?: ReceituariosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os receituários do ambiente
 */

export function useReceituariosControllerListar<TData = Awaited<ReturnType<typeof receituariosControllerListar>>, TError = ErroResponse>(
 params?: ReceituariosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReceituariosControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getReceituariosControllerCriarUrl = () => {




  return `/v1/receituarios`
}

/**
 * @summary Cria o receituário. Item com `produtoParceiroId` emite IMPORT_RECEITUARIO.
 */
export const receituariosControllerCriar = async (criarReceituarioDto: CriarReceituarioDto, options?: Parameters<typeof httpClient>[1]): Promise<ReceituarioResponse> => {

  return httpClient<ReceituarioResponse>(getReceituariosControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarReceituarioDto)
  }
);}





export const getReceituariosControllerCriarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerCriar>>, TError,{data: CriarReceituarioDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerCriar>>, TError,{data: CriarReceituarioDto}, TContext> => {

const mutationKey = ['receituariosControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receituariosControllerCriar>>, {data: CriarReceituarioDto}> = (props) => {
          const {data} = props ?? {};

          return  receituariosControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReceituariosControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof receituariosControllerCriar>>>
    export type ReceituariosControllerCriarMutationBody = CriarReceituarioDto
    export type ReceituariosControllerCriarMutationError = unknown

    /**
 * @summary Cria o receituário. Item com `produtoParceiroId` emite IMPORT_RECEITUARIO.
 */
export const useReceituariosControllerCriar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerCriar>>, TError,{data: CriarReceituarioDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof receituariosControllerCriar>>,
        TError,
        {data: CriarReceituarioDto},
        TContext
      > => {
      return useMutation(getReceituariosControllerCriarMutationOptions(options), queryClient);
    }
    export const getReceituariosControllerObterUrl = (id: string,) => {




  return `/v1/receituarios/${id}`
}

/**
 * @summary Detalha um receituário com os itens
 */
export const receituariosControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<ReceituarioResponse> => {

  return httpClient<ReceituarioResponse>(getReceituariosControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReceituariosControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/receituarios/${id}`
    ] as const;
    }


export const getReceituariosControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof receituariosControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReceituariosControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof receituariosControllerObter>>> = ({ signal }) => receituariosControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReceituariosControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof receituariosControllerObter>>>
export type ReceituariosControllerObterQueryError = ErroResponse


export function useReceituariosControllerObter<TData = Awaited<ReturnType<typeof receituariosControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof receituariosControllerObter>>,
          TError,
          Awaited<ReturnType<typeof receituariosControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReceituariosControllerObter<TData = Awaited<ReturnType<typeof receituariosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof receituariosControllerObter>>,
          TError,
          Awaited<ReturnType<typeof receituariosControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReceituariosControllerObter<TData = Awaited<ReturnType<typeof receituariosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha um receituário com os itens
 */

export function useReceituariosControllerObter<TData = Awaited<ReturnType<typeof receituariosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReceituariosControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getReceituariosControllerAtualizarUrl = (id: string,) => {




  return `/v1/receituarios/${id}`
}

/**
 * @summary Edita e grava a versão anterior. Assinado responde 409.
 */
export const receituariosControllerAtualizar = async (id: string,
    atualizarReceituarioDto: AtualizarReceituarioDto, options?: Parameters<typeof httpClient>[1]): Promise<ReceituarioResponse> => {

  return httpClient<ReceituarioResponse>(getReceituariosControllerAtualizarUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarReceituarioDto)
  }
);}





export const getReceituariosControllerAtualizarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerAtualizar>>, TError,{id: string;data: AtualizarReceituarioDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerAtualizar>>, TError,{id: string;data: AtualizarReceituarioDto}, TContext> => {

const mutationKey = ['receituariosControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receituariosControllerAtualizar>>, {id: string;data: AtualizarReceituarioDto}> = (props) => {
          const {id,data} = props ?? {};

          return  receituariosControllerAtualizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReceituariosControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof receituariosControllerAtualizar>>>
    export type ReceituariosControllerAtualizarMutationBody = AtualizarReceituarioDto
    export type ReceituariosControllerAtualizarMutationError = ErroResponse

    /**
 * @summary Edita e grava a versão anterior. Assinado responde 409.
 */
export const useReceituariosControllerAtualizar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerAtualizar>>, TError,{id: string;data: AtualizarReceituarioDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof receituariosControllerAtualizar>>,
        TError,
        {id: string;data: AtualizarReceituarioDto},
        TContext
      > => {
      return useMutation(getReceituariosControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getReceituariosControllerExcluirUrl = (id: string,) => {




  return `/v1/receituarios/${id}`
}

/**
 * @summary Exclusão lógica. Assinado responde 409.
 */
export const receituariosControllerExcluir = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getReceituariosControllerExcluirUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getReceituariosControllerExcluirMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerExcluir>>, TError,{id: string}, TContext> => {

const mutationKey = ['receituariosControllerExcluir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receituariosControllerExcluir>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  receituariosControllerExcluir(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReceituariosControllerExcluirMutationResult = NonNullable<Awaited<ReturnType<typeof receituariosControllerExcluir>>>

    export type ReceituariosControllerExcluirMutationError = unknown

    /**
 * @summary Exclusão lógica. Assinado responde 409.
 */
export const useReceituariosControllerExcluir = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof receituariosControllerExcluir>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getReceituariosControllerExcluirMutationOptions(options), queryClient);
    }
    export const getReceituariosControllerPdfUrl = (id: string,) => {




  return `/v1/receituarios/${id}/pdf`
}

/**
 * @summary Gera o PDF. Assinado usa o snapshot; rascunho é prévia.
 */
export const receituariosControllerPdf = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getReceituariosControllerPdfUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReceituariosControllerPdfQueryKey = (id: string,) => {
    return [
    `/v1/receituarios/${id}/pdf`
    ] as const;
    }


export const getReceituariosControllerPdfQueryOptions = <TData = Awaited<ReturnType<typeof receituariosControllerPdf>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerPdf>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReceituariosControllerPdfQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof receituariosControllerPdf>>> = ({ signal }) => receituariosControllerPdf(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerPdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReceituariosControllerPdfQueryResult = NonNullable<Awaited<ReturnType<typeof receituariosControllerPdf>>>
export type ReceituariosControllerPdfQueryError = unknown


export function useReceituariosControllerPdf<TData = Awaited<ReturnType<typeof receituariosControllerPdf>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerPdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof receituariosControllerPdf>>,
          TError,
          Awaited<ReturnType<typeof receituariosControllerPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReceituariosControllerPdf<TData = Awaited<ReturnType<typeof receituariosControllerPdf>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerPdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof receituariosControllerPdf>>,
          TError,
          Awaited<ReturnType<typeof receituariosControllerPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReceituariosControllerPdf<TData = Awaited<ReturnType<typeof receituariosControllerPdf>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerPdf>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gera o PDF. Assinado usa o snapshot; rascunho é prévia.
 */

export function useReceituariosControllerPdf<TData = Awaited<ReturnType<typeof receituariosControllerPdf>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receituariosControllerPdf>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReceituariosControllerPdfQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getReceituariosControllerAssinarUrl = (id: string,) => {




  return `/v1/receituarios/${id}/assinar`
}

/**
 * @summary Assina, numera e congela. Chave SEPARADA de `criar` — é o que impede assinar pelo médico. Com certificado A1, o PDF sai assinado digitalmente (PAdES).
 */
export const receituariosControllerAssinar = async (id: string,
    assinarDocumentoDto?: AssinarDocumentoDto, options?: Parameters<typeof httpClient>[1]): Promise<ReceituarioResponse> => {

  return httpClient<ReceituarioResponse>(getReceituariosControllerAssinarUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(assinarDocumentoDto)
  }
);}





export const getReceituariosControllerAssinarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerAssinar>>, TError,{id: string;data?: AssinarDocumentoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerAssinar>>, TError,{id: string;data?: AssinarDocumentoDto}, TContext> => {

const mutationKey = ['receituariosControllerAssinar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receituariosControllerAssinar>>, {id: string;data?: AssinarDocumentoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  receituariosControllerAssinar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReceituariosControllerAssinarMutationResult = NonNullable<Awaited<ReturnType<typeof receituariosControllerAssinar>>>
    export type ReceituariosControllerAssinarMutationBody = AssinarDocumentoDto | undefined
    export type ReceituariosControllerAssinarMutationError = ErroResponse

    /**
 * @summary Assina, numera e congela. Chave SEPARADA de `criar` — é o que impede assinar pelo médico. Com certificado A1, o PDF sai assinado digitalmente (PAdES).
 */
export const useReceituariosControllerAssinar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerAssinar>>, TError,{id: string;data?: AssinarDocumentoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof receituariosControllerAssinar>>,
        TError,
        {id: string;data?: AssinarDocumentoDto},
        TContext
      > => {
      return useMutation(getReceituariosControllerAssinarMutationOptions(options), queryClient);
    }
    export const getReceituariosControllerCompartilharUrl = (id: string,) => {




  return `/v1/receituarios/${id}/compartilhar`
}

/**
 * @summary Gera link com prazo, com registro de cada abertura
 */
export const receituariosControllerCompartilhar = async (id: string,
    compartilharReceituarioDto: CompartilharReceituarioDto, options?: Parameters<typeof httpClient>[1]): Promise<LinkCompartilhadoResponse> => {

  return httpClient<LinkCompartilhadoResponse>(getReceituariosControllerCompartilharUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(compartilharReceituarioDto)
  }
);}





export const getReceituariosControllerCompartilharMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerCompartilhar>>, TError,{id: string;data: CompartilharReceituarioDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerCompartilhar>>, TError,{id: string;data: CompartilharReceituarioDto}, TContext> => {

const mutationKey = ['receituariosControllerCompartilhar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receituariosControllerCompartilhar>>, {id: string;data: CompartilharReceituarioDto}> = (props) => {
          const {id,data} = props ?? {};

          return  receituariosControllerCompartilhar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReceituariosControllerCompartilharMutationResult = NonNullable<Awaited<ReturnType<typeof receituariosControllerCompartilhar>>>
    export type ReceituariosControllerCompartilharMutationBody = CompartilharReceituarioDto
    export type ReceituariosControllerCompartilharMutationError = ErroResponse

    /**
 * @summary Gera link com prazo, com registro de cada abertura
 */
export const useReceituariosControllerCompartilhar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerCompartilhar>>, TError,{id: string;data: CompartilharReceituarioDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof receituariosControllerCompartilhar>>,
        TError,
        {id: string;data: CompartilharReceituarioDto},
        TContext
      > => {
      return useMutation(getReceituariosControllerCompartilharMutationOptions(options), queryClient);
    }
    export const getReceituariosControllerCompartilharPorEmailUrl = (id: string,) => {




  return `/v1/receituarios/${id}/compartilhar/email`
}

/**
 * @summary Envia o receituário ao tutor por e-mail, com o PDF anexo
 */
export const receituariosControllerCompartilharPorEmail = async (id: string,
    compartilharReceituarioPorEmailDto: CompartilharReceituarioPorEmailDto, options?: Parameters<typeof httpClient>[1]): Promise<LinkCompartilhadoResponse> => {

  return httpClient<LinkCompartilhadoResponse>(getReceituariosControllerCompartilharPorEmailUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(compartilharReceituarioPorEmailDto)
  }
);}





export const getReceituariosControllerCompartilharPorEmailMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerCompartilharPorEmail>>, TError,{id: string;data: CompartilharReceituarioPorEmailDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerCompartilharPorEmail>>, TError,{id: string;data: CompartilharReceituarioPorEmailDto}, TContext> => {

const mutationKey = ['receituariosControllerCompartilharPorEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receituariosControllerCompartilharPorEmail>>, {id: string;data: CompartilharReceituarioPorEmailDto}> = (props) => {
          const {id,data} = props ?? {};

          return  receituariosControllerCompartilharPorEmail(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReceituariosControllerCompartilharPorEmailMutationResult = NonNullable<Awaited<ReturnType<typeof receituariosControllerCompartilharPorEmail>>>
    export type ReceituariosControllerCompartilharPorEmailMutationBody = CompartilharReceituarioPorEmailDto
    export type ReceituariosControllerCompartilharPorEmailMutationError = ErroResponse

    /**
 * @summary Envia o receituário ao tutor por e-mail, com o PDF anexo
 */
export const useReceituariosControllerCompartilharPorEmail = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receituariosControllerCompartilharPorEmail>>, TError,{id: string;data: CompartilharReceituarioPorEmailDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof receituariosControllerCompartilharPorEmail>>,
        TError,
        {id: string;data: CompartilharReceituarioPorEmailDto},
        TContext
      > => {
      return useMutation(getReceituariosControllerCompartilharPorEmailMutationOptions(options), queryClient);
    }
